/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseSalePointDto } from '../../models/api-response-sale-point-dto';
import { SalePointDto } from '../../models/sale-point-dto';

export interface CreateSalePoint$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: SalePointDto
}

export function createSalePoint(http: HttpClient, rootUrl: string, params: CreateSalePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSalePointDto>> {
  const rb = new RequestBuilder(rootUrl, createSalePoint.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseSalePointDto>;
    })
  );
}

createSalePoint.PATH = '/v1/api/sale-points';
